import { render, staticRenderFns } from "./simplifyEvBike.vue?vue&type=template&id=5f94dba0&scoped=true"
import script from "./simplifyEvBike.vue?vue&type=script&lang=js"
export * from "./simplifyEvBike.vue?vue&type=script&lang=js"
import style0 from "./simplifyEvBike.vue?vue&type=style&index=0&id=5f94dba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f94dba0",
  null
  
)

export default component.exports